import { render, staticRenderFns } from "./CardLayout.vue?vue&type=template&id=027dd6d8&scoped=true&lang=html"
import script from "./CardLayout.vue?vue&type=script&lang=js"
export * from "./CardLayout.vue?vue&type=script&lang=js"
import style0 from "./CardLayout.vue?vue&type=style&index=0&id=027dd6d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027dd6d8",
  null
  
)

export default component.exports